import { Divider, Radio, Row, Skeleton, Space } from 'antd'
import { RadioGroupProps } from 'antd/lib/radio'
import styles from './RadioButtonGroup.module.scss'
import React from 'react'
import { t } from 'i18next'
import CheckboxButton from '@shared/CheckboxButton'
import { orderStatusListType } from 'store/types/salaryCard'
import { secureLocalStorageGet } from '../../app/helpers'
import { StatusType } from 'pages/Orders/SalaryCardOrder/constants/fieldValues.constant'

type RadioButtonGroupProps = {
  label?: string
  options: orderStatusListType[]
  loading?: boolean
  customTranslationKey?: string
} & Omit<RadioGroupProps, 'options'>

function RadioButtonGroup(props: RadioButtonGroupProps) {
  const { loading, label, options, customTranslationKey,...otherProps } = props
  const isSigner = secureLocalStorageGet('rol') === 2
  const MUST_BE_SIGNED = options.find(
    (i) => i.status === StatusType.PENDING_SIGNER
  )

  // if (loading) {
  //   return (
  //     <Space>
  //       <Skeleton.Button size="default" shape="round" block={false} />
  //       <Skeleton.Button size="default" shape="round" block={false} />
  //       <Skeleton.Button size="default" shape="round" block={false} />
  //     </Space>
  //   )
  // }

  return (
    <Space>
      {isSigner && (
        <>
          <CheckboxButton
            badgeValue={
              MUST_BE_SIGNED ? (MUST_BE_SIGNED.count as unknown as string) : '0'
            }
            checked={otherProps.value === 'FOR_MUST_BE_SIGNED'}
            {...otherProps}
            value={MUST_BE_SIGNED ? 'FOR_MUST_BE_SIGNED' : ''}
            title={t('transfers.forMySigning')}
          />
          <Divider type="vertical" />
        </>
      )}
      {options.length > 0 && (
        <Row style={{ alignItems: 'center', gap: 8 }}>
          {label && <label htmlFor="radiobutton">{label}: </label>}
          <Radio.Group
            id="radiobutton"
            className={styles.radioButtons}
            optionType="button"
            buttonStyle="outline"
            {...otherProps}
          >
            {options.map((option, index) => (
              <Radio.Button
                style={{
                  order: Object.keys(StatusType).indexOf(
                    StatusType[option.status]
                  ),
                }}
                key={option.status}
                value={option.status}
              >
                {t(
                  `${customTranslationKey||"orders.salaryCardOrder.buttonsLabels.RadioButtonGroup"}.${option.status}`
                )}{' '}
                <span className="count">{option.count}</span>
              </Radio.Button>
            ))}
          </Radio.Group>
        </Row>
      )}
    </Space>
  )
}

export default RadioButtonGroup
